import request from '@/utils/axios'

// 获取热门公告列表
export function hotNoticeList () {
  return request({
    url: '/information/newestNotice',
    method: 'post'
  })
}

// 获取公告列表
export function noticeList (data) {
  return request({
    url: '/information/noticeList',
    method: 'post',
    data: data
  })
}

// 获取公告详情
export function noticeDetail (data) {
  return request({
    url: '/information/noticeDetail',
    method: 'post',
    data
  })
}
